import { defineFieldFormInterface } from "~/entities/field";
import InterfacePresentationDividerAliasType from "./InterfacePresentationDividerAliasType.vue";

export default defineFieldFormInterface({
  interface: "presentation-divider",
  type: "alias",
  component: InterfacePresentationDividerAliasType,
});
